import React from "react";
import { Avatar } from "@mui/material";
import { getAvatarColor, getInitials, getPartnerAvatarUrl } from "./livechatDisplayUtils";

/**
 * DEV-1422 — avatar percakapan/kontak: foto mitra kalau ada `avatarPath` (path aset Lavender), selain
 * itu (atau gambar gagal dimuat — MUI Avatar otomatis jatuh ke children) inisial nama seperti sebelumnya.
 * Sesi brand customer tidak punya avatarPath, jadi tampilannya tidak berubah.
 */
export default function PartnerAvatar({ name, avatarPath, size = 40, fontSize = 15, sx }) {
    const src = getPartnerAvatarUrl(avatarPath) || undefined;
    return (
        <Avatar
            src={src}
            alt={src ? name : undefined}
            imgProps={{ loading: "lazy" }}
            sx={{ bgcolor: getAvatarColor(name), width: size, height: size, fontSize, ...sx }}
        >
            {getInitials(name)}
        </Avatar>
    );
}
